module.exports = __webpack_public_path__ + "img/implants.9fd97aa0.png";